export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";